import { inject } from '@angular/core';

import moment from 'moment-timezone';

import { TimeAgoBase } from '@core/time-legacy';
import type { IconName } from '@core/user-interface-legacy';

import { TellentImpactInsightName } from './types';

export function formatNumberWithCommas(value?: number): string {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '';
}

export function toPercentage(value: number): string {
  return `${Number((value * 100).toFixed(2))}%`;
}

const toTimeAgo = (timeAgoBase: TimeAgoBase) => (value: number) => {
  const date = moment().add(value, 'h').toDate();
  return `~${timeAgoBase.getTime(date, { omitSuffix: true })}`;
};

type ImpactTrackerInsightsTranslationsMapT = () => Record<
  TellentImpactInsightName,
  {
    title: string;
    label: string;
    icon: IconName;
    formatFns:
      | [(number: number) => string]
      | [(number: number) => string, (number: number) => string];
    tooltip: string;
  }
>;

export const ImpactTrackerInsightsTranslationsMap: ImpactTrackerInsightsTranslationsMapT = () => {
  const timeAgoBase = inject(TimeAgoBase);

  return {
    candidates_and_hires: {
      icon: 'getting-started-candidates-filled',
      label: 'tlc.impact_tracker.metric_cards.candidates.label',
      title: 'tlc.impact_tracker.metric_cards.candidates.title',
      formatFns: [formatNumberWithCommas, formatNumberWithCommas],
      tooltip: 'tlc.impact_tracker.metric_cards.candidates.tooltip',
    },
    views_and_conversion: {
      icon: 'nav-careershub',
      label: 'tlc.impact_tracker.metric_cards.careers.label',
      title: 'tlc.impact_tracker.metric_cards.careers.title',
      formatFns: [formatNumberWithCommas, toPercentage],
      tooltip: 'tlc.impact_tracker.metric_cards.careers.tooltip',
    },
    automations: {
      icon: 'access-time',
      label: 'tlc.impact_tracker.metric_cards.automated_actions.label',
      title: 'tlc.impact_tracker.metric_cards.automated_actions.title',
      formatFns: [toTimeAgo(timeAgoBase)],
      tooltip: 'tlc.impact_tracker.metric_cards.automated_actions.tooltip',
    },
    active_and_new_users: {
      icon: 'employee',
      label: 'tlc.impact_tracker.metric_cards.active_employee.label',
      title: 'tlc.impact_tracker.metric_cards.active_employee.title',
      formatFns: [formatNumberWithCommas],
      tooltip: 'tlc.impact_tracker.metric_cards.active_employee.tooltip',
    },
    actions_performed: {
      icon: 'track-changes',
      label: 'tlc.impact_tracker.metric_cards.performed_actions.label',
      title: 'tlc.impact_tracker.metric_cards.performed_actions.title',
      formatFns: [formatNumberWithCommas, formatNumberWithCommas],
      tooltip: 'tlc.impact_tracker.metric_cards.performed_actions.tooltip',
    },
    postings_and_job_boards: {
      icon: 'timetable',
      label: 'tlc.impact_tracker.metric_cards.absence_management.label',
      title: 'tlc.impact_tracker.metric_cards.absence_management.title',
      formatFns: [formatNumberWithCommas, formatNumberWithCommas],
      tooltip: 'tlc.impact_tracker.metric_cards.absence_management.tooltip',
    },
  };
};
